import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import proj4 from "proj4";

window.proj4 = window.proj4 || proj4;

export default class StackBarChart extends React.Component {
    constructor(props) {
        super(props)
        this.state = { options: this.updateData() }
    }

    updateData() {

        const fulldata = this.props.data
        console.log(fulldata)

        const labels = fulldata.datasets.map((dataset) => {
            return dataset.label
        })
        const data = fulldata.datasets.map((dataset) => {
            return dataset.data
        })

        const xAxisLabels = fulldata.labels

        const colors = fulldata.datasets.map((dataset) => {
            return dataset.borderColor
        })

        const maxcolors = fulldata.maxcolors

        const yAxisTitle = this.props.yAxisTitle
        const gridLinesAmount = this.props.gridLinesAmount
        const xAxisTitle = this.props.xAxisTitle

        const page = this
        return {
            exporting: {
                enabled: true
            },
            chart: {
                type: 'bar',
                // backgroundColor: 'rgba(100,100,100,0.1)',
                scrollablePlotArea: {
                    minHeight: 10
                },
            },
            title: '',
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                }
            },
            yAxis: {
                title: { text: yAxisTitle },
                tickAmount: gridLinesAmount,
            },
            xAxis: {
                title: { text: xAxisTitle },
                categories: xAxisLabels,
                labels: {
                    formatter: function () {
                        if (this.value !== this.pos)
                            return '<span style="font-size: 20px; color: ' + maxcolors[this.axis.categories.indexOf(this.value)] + '">\u25CF</span>' + this.value
                    },
                },
                min: 0,
                max: 10,
            },
            series: data.map((line_data, index) => {
                return {
                    name: labels[index],
                    data: line_data,
                    color: colors[index],
                    events: {
                        click: function (e) {
                            page.props.changehospital(e.point.category)
                        }
                    }
                }
            }),
            tooltip: {
                formatter: function () {
                    const sumfilm = this.points.reduce(function (a, b) {
                        return a + b.y;
                    }, 0)
                    return (
                        "<b>" +
                        this.x +
                        "</b><br/>" +
                        this.points.sort(function (a, b) {
                            return b.y - a.y; // Sort tooltip by most films
                        }).map((point) => {
                            return '<span style="color:' + point.color + '">\u25CF</span>' + point.series.name + ': <b>' +
                                point.percentage.toFixed(2) + '%</b>' +
                                // ' (' + point.y + ')' +
                                '<br/>'
                        }).join('') +
                        '<hr/>Total: ' + sumfilm + ' Films'
                    )
                },
                useHTML: true,
                shared: true
            },
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.display)
            return
        if (prevProps.data !== this.props.data) {
            this.setState({ options: this.updateData() })
        }
    }

    render() {
        return (
            <div style={{ display: (this.props.display ? 'inline' : 'none') }}>
                <HighchartsReact
                    updateArgs={[true, true, true]}
                    highcharts={Highcharts}
                    options={this.state.options}
                    containerProps={{
                        style: {
                            height: this.props.height,
                        }
                    }}
                />
            </div>
        );
    }
}